module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 2_Skills_Check boxes.ab29a53b.svg";